import { render, staticRenderFns } from "./kiosk.vue?vue&type=template&id=1c22fa7d&"
import script from "./kiosk.vue?vue&type=script&lang=js&"
export * from "./kiosk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports